import { defineStore } from 'pinia'
import { version } from '../package.json'

interface PARAMS_LANG {
  label_id: number
  label_uri: string
  iso_code: string
  is_default: boolean
  label_name: string
}
const lang = import.meta.env.VITE_APP_LANG || ''
const tmpLanguages = [{
  label_id: 1,
  label_uri: 'en',
  iso_code: 'en-US',
  label_name: 'English',
  is_default: true,
},
{
  label_id: 2,
  label_uri: 'id',
  iso_code: 'id-ID',
  label_name: 'Indonesia',
  is_default: false,
}]
const template = (import.meta.env.VITE_APP_TEMPLATE)?.toLowerCase() || 'savoy'
export const useSettingStore = defineStore('setting', {
  state: () => ({
    template,
    hotelId: Number(import.meta.env.VITE_APP_HOTEL_ID),
    brand: import.meta.env.VITE_APP_HOTEL_NAME || '',
    showSidebarMenu: false,
    versionPinia: version,
    disableSplashScreen: true,
    hasSplashScreen: false,
    version: import.meta.env.VITE_APP_VERSION,
    lang,
    lang_id: tmpLanguages.filter((el: {
      label_id: number
      label_uri: string
    }) => el?.label_uri === lang)?.[0]?.label_id,
    languages: tmpLanguages,
    cssVars: {
    },
  }),
  getters: {
    getLang(): string {
      return this.lang
    },
  },
  actions: {
    setLanguages(payload: PARAMS_LANG[]) {
      this.languages = payload
    },
    setLanguage(payload: PARAMS_LANG) {
      if (payload && Object.keys(payload).length) {
        this.lang = payload.label_uri
        this.lang_id = Number(payload.label_id)
      }
    },
    setLang(payload: string) {
      this.lang = payload
    },
    setDisableSplashScreen(payload: boolean) {
      if (import.meta.env.VITE_APP_ENABLE_SPLASH_SCREEN)
        this.disableSplashScreen = payload
    },
    setHasSplashScreen(payload: boolean) {
      this.hasSplashScreen = payload
    },
    setShowSidebarMenu(payload: boolean) {
      this.showSidebarMenu = payload
    },
    setCssVars(payload: object) {
      this.cssVars = payload
    },
  },
})
